import React, { useState, useEffect } from "react";
import SortCommand from "../SortCommand/SortCommand";
import "../../Styles/globalStyle.css";
import useSize from "../../../Hooks/useSize.js";
import useBuildStyle from "../../../Hooks/useBuildStyle";

export default function Label(props) {
  const [isDragOver, setDragover] = useState(false);
  const [actualWidth, actualHeight] = useSize(props.style.width.value, props.style.height.value, props.data.id);
  const buildStyle = useBuildStyle();

  useEffect(() => {
    props.updateSize(props.data.id, actualWidth, actualHeight);
  }, [actualWidth,actualHeight]);

  const getStyle = () => {
    var newStyle = buildStyle(props.style);

    newStyle["border"] = isDragOver ? "1px dashed #1f79e1" : props.style.border.value;
    return newStyle;
  };

  const onDrag = (e, dragOver) => {
    if (dragOver !== isDragOver)
      setDragover(dragOver);
   
  };

  const onDropColumn = (e) => {
    e.stopPropagation();
    props.onDropColumn(e, props.data);
    setDragover(false);
  };
  
  const getLabelComponent = (e) => {
    switch (props.data.properties.type.value) {
      case "H1":
        return <h1>{props.data.properties.text.value}</h1>
      case "H2":
        return <h2>{props.data.properties.text.value}</h2>
      case "H3":
        return <h3>{props.data.properties.text.value}</h3>
      case "H4":
        return <h4>{props.data.properties.text.value}</h4>
      case "H5":
        return <h5>{props.data.properties.text.value}</h5>
      case "H6":
        return <h6>{props.data.properties.text.value}</h6>
      
      default:
        return props.data.properties.text.value
    }
  };

  return (
    
    <div
      draggable={props.draggable}
      onClick={props.onClick}
      style={getStyle()}
      id={props.data.id}
      onDragStart={(e) => props.onDragStart(e)}
      onDrop={(e) => props.onlyLabel && onDropColumn(e)}
      onDragOver={(e) => props.onlyLabel && onDrag(e, true)}
      onDragLeave={(e) => props.onlyLabel && onDrag(e, false)}
    >
      {getLabelComponent()}
      {props.sortable && (
        <div
          style={{
            paddingTop: "2px",
            marginLeft: "auto",
          }}
        >
          <SortCommand />
        </div>
      )}
     
    </div>
  );
}
